import { AfterViewInit, Component, Input, OnDestroy } from "@angular/core";
import { IntervalService } from '../../services/interval/interval.service';

@Component({
  selector: 'clock',
  templateUrl: './clock.component.html',
  styleUrls: ['./clock.component.scss']
})
export class ClockComponent implements AfterViewInit, OnDestroy {

  @Input() type: string = 'normal'; //type can be 'normal' or 'old'
  @Input() color: string = 'white'; //can only be used if type is 'normal'
  @Input() showDigits = true;
  @Input() digitsPosition = 'bottom'; // top, bottom, right, left, none
  @Input() size;
  @Input() fontSize;
  @Input() fontWeight = 'normal';
  @Input() elId = 'clockId';

  hours;
  minutes;
  id = Date.now().toString(36) + Math.random().toString(36).substr(2);

  constructor() {
    this.calculateTime();
  }

  ngAfterViewInit() {
    this.calculateTime(true);
    IntervalService.set('clock' + this.elId, () => {
      this.calculateTime(true);
    }, 250);
  }

  ngOnDestroy() {
    IntervalService.clear('clock' + this.elId);
  }

  private calculateTime(withLines = false) {
    if (withLines) {
      let clocks = document.querySelectorAll('.' + this.elId + (this.type !== 'normal' ? ' .old-clock-background' : ' #normalClock'));
      clocks.forEach((clock: any) => {
        clock.style.fill = this.color;
      });

      const hourLine: any = document.querySelectorAll('.' + this.elId + ' .line-hour');
      const minuteLine: any = document.querySelectorAll('.' + this.elId + ' .line-minute');
      const secondLine: any = document.querySelectorAll('.' + this.elId + ' .line-second');

      if (hourLine && minuteLine && secondLine) {
        hourLine.forEach(line => {
          line.setAttribute('transform', 'rotate(' + ((((new Date().getHours() + 24) % 12 || 12) + new Date().getMinutes() / 60) * 30) + ' 120 120)');
        })
        minuteLine.forEach(line => {
          line.setAttribute('transform', 'rotate(' + 6 * new Date().getMinutes() + ' 120 120)');
        })
        secondLine.forEach(line => {
          line.setAttribute('transform', 'rotate(' + 6 * new Date().getSeconds() + ' 120 120)');
        })
      }
    }

    this.minutes = +new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
    this.hours = +new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours();
  }
}
